import { render, staticRenderFns } from "./VerCotacoesBotaoBarra.vue?vue&type=template&id=6040232e"
import script from "./VerCotacoesBotaoBarra.vue?vue&type=script&lang=js"
export * from "./VerCotacoesBotaoBarra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports